<template>
    <div class="home">
        <div class="banner">
            <img class='bg-pic' src="http://music.chinaman.cn/mybigdatas/icm2030/new0616/banner0040.jpg" alt="">
            <div class="font">
                <div class="w-1200">
                    <div>
                        <div class="banner-title1">
                            INTERNATIONAL CONGRESS OF MATHEMATICIANS · 2030
                        </div>
                        <div class="banner-title2">
                            Mathematics
                        </div>
                        <div class="banner-title3">
                            Beyond Borders
                        </div>
                        <div class="banner-title4">
                            Hong Kong invites the world’s mathematical community to gather where East meets West
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-1" id="contact1">
            <div class="w-1200">
                <div class="big-title">
                    Hong Kong’s Offer At a Glance
                </div>
                <div class="lists">
                    <div class="list card-item" :class="['list-' + (index + 1),
                    { 'card-scale-active': isCardScaled(item.name) }]" @click="toggleCardScale(item.name)"
                        v-for="(item, index) in sixFigures" :key="item.name">
                        <div class="num">
                            {{ item.num }}
                        </div>
                        <div class="name">
                            {{ item.name }}
                        </div>
                        <div class="list-text" v-html="item.text">
                        </div>
                        <div class="list-img" v-if="item.img">
                            <img src="http://music.chinaman.cn/mybigdatas/icm2030/new/home-img1.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-2" id="contact2">
            <div class="w-1200">
                <div class="big-title">
                    Hong Kong: A Crossroads of East and West
                </div>
                <div class="word-con">
                    <div class="pics">
                        <img src="http://music.chinaman.cn/mybigdatas/icm2030/new/chair-pic1.jpg" alt="">
                        <div class="tip"><i>Text in the image translates: "East-West Communication"</i></div>
                    </div>
                    <div class="word-text">

                        <div class="h5-bg">
                            <div class="word-title">
                                Message from the Chairman
                            </div>
                            <p>
                                "Mathematics has always crossed borders. From the ancient Silk Routes that united
                                Eastern and Western traditions of thought, to the global correspondence that produced
                                the great breakthroughs of the twentieth century, our discipline has always belonged to
                                all of humanity.
                            </p>
                            <p>
                                Hong Kong stands at that crossing point — a city where Chinese and Western intellectual
                                traditions meet and strengthen each other, where five world-class universities pursue
                                mathematics across every dimension: pure, applied, statistical, and computational. It is
                                a place where the world arrives every day.
                            </p>
                            <p>
                                We invite the global mathematical community to gather here in 2030. Hong Kong is ready.
                                And it is our deepest commitment to welcome every member of our community, so that
                                together we may shape the future of mathematical sciences."
                            </p>
                        </div>
                        <div class="h5-padding">
                            <div class="name">Professor Shing-Tung Yau</div>
                            <div class="desc">
                                Chairman, ICM 2030 Hong Kong Organising Committee
                            </div>
                            <div class="desc-text">
                                Distinguished Professor-at-Large and Director, Institute of Mathematical Sciences,
                                CUHK <br>
                                Founding Director, Zhizhen School of Interdisciplinary Mathematical Sciences. CUHK
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-3" id="contact3">
            <div class="w-1200">
                <div class="big-title">
                    Latest News On ICM 2030
                </div>
                <div class="lists">
                    <div class="list cup" :class="'list-' + Number(index + 1)" @click="windowOpenFn(item)"
                        v-for="(item, index) in newsList1" :key="(item.news_id || item.news_title) + '_' + currentPage">
                        <div class="img">
                            <img :src="item.image_url" alt="">
                            <i v-if="item.video_url" class="el-icon-caret-right"></i>
                        </div>
                        <div class="text-con" :class="'text-con-' + Number(index + 1)">
                            <div class="time"> {{ item.create_time }}</div>
                            <div class="name">
                                {{ item.news_title }}...
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-con">
                    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
                        :page-size="3" layout="prev, pager, next" :total="total">
                    </el-pagination>
                </div>

            </div>
        </div>
        <div class="section-4" id="contact4">
            <div class="w-1200">
                <div class="big-title">
                    Endorsed by leading organisations worldwide.
                </div>
                <div class="text-con">
                    <!-- Mathematical societies, research institutions, and government bodies across the world -->
                </div>
                <div class="lists">
                    <div class="list" v-for="(item, index) in organizerList" :key="index">
                        <div class="imgs">
                            <img :src="item.image_url" alt="">
                        </div>
                        <p class="list-title">{{ item.news_title }}</p>
                    </div>
                    <div class="list img-list-more">
                        <p class="imgs" style="color:#DBAE00">
                            <!-- <i class="el-icon-more"></i> -->
                            30+
                        </p>
                        <p class="list-title">
                            <!-- And many more across Asia, Europe and the Americas -->
                            endorsing organisations across the world
                        </p>
                    </div>
                </div>
                <!-- <div class="num">30+</div>
                <div class="num-desc">
                    endorsing organisations across the world
                </div> -->
                <!-- <div class="read-more-btn" @click="toPageFn('/sponsorList')">
                    Read More <i class="el-icon-right"></i>
                </div> -->
            </div>

        </div>
        <!-- <el-dialog title="新闻标题标题" :visible.sync="dialogVisible" width="70%">
            <iframe class="iframe" width="100%" height="605"
                src="https://www.youtube.com/embed/w2xW1BQaTjc?si=6peV33jSrRkD-pgf" title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
            </iframe>
        </el-dialog> -->
    </div>
</template>
<script>

export default {
    name: 'HeaderCon',
    components: {},
    data() {
        return {
            dialogVisible: true,
            currentPage: 1,
            total: 4,
            routerList: [
                {
                    name: 'Home',
                    path: '/'
                },
                {
                    name: 'GA & ICM',
                    path: '/gaIcm'
                },
                {
                    name: 'Organizers',
                    path: '/organizers'
                },
                {
                    name: 'Support for participants',
                    path: '/comprehensiveSupport'
                },
                {
                    name: 'Hong Kong',
                    path: '/why'
                },
                {
                    name: 'Media Centre',
                    path: '/mediaCentre'
                },
            ],
            sixFigures: [{
                small: 'USD',
                num: '16M+',
                name: 'Committed funding',
                text: 'USD 16 million already secured from nine named institutions with no contingency clauses.',
            }, {
                small: '',
                num: 'Complimentary',
                name: 'Accommodation for all registered participants',
                text: 'Pre-arranged lodging provided at no cost upon request, removing every financial barrier to attendance.',
            }, {
                num: '4,000',
                name: 'Mathematicians fully funded - flights, lodging and registration',
                text: '',
                img: true,
                small: ''
            }, {
                small: '',
                num: '5',
                name: 'QS Top 100 Universities as partners',
                text: 'Partner universities will provide library access for registered congress participants.',// 开放图书馆那句话
            }, {
                small: '',
                num: '170+',
                name: 'Countries with visa-free access',
                text: 'With 140 airlines spanning 200+ destinations and English as an official language, Hong Kong offers seamless connectivity and accessibility for mathematicians worldwide.',
            }, {
                small: '',
                num: '#1',
                name: 'Ranking in infrastructure security',
                text: 'Hong Kong ranks first globally for infrastructure security and is recognised as the world’s best city for public transport, giving every delegate peace of mind and ease of movement.',
            },],

            newsList: [],
            loading: false,
            organizerList: [],

            newsList1: []
        }
    },
    mounted() {
        if (this.$route.query.currentNav) {
            this.$nextTick(() => {
                this.$utils.scrollIntoView('contact' + this.$route.query.currentNav)
            })
        }
        this.getNewsFn()
        this.getNewsFn1()
        this.getOrganizersFn()
    },
    watch: {
        '$route.query.currentNav': function (val) {
            console.log(val, 'val')
            this.$nextTick(() => {
                this.$utils.scrollIntoView('contact' + val)
            })
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val
            console.log(val, 'val----')
            this.getNewsFn1()
        },
        getNewsFn1() {
            this.loading = true;
            this.$http.news_list({
                type_id: 755,
                page: this.currentPage,
                pagesize: 3
            }).then(res => {
                this.loading = false;
                this.newsList1 = res.data || [];
                this.total = res.count;
                console.log(this.newsList1, 'this.newsList')
            })
        },
        getTwoGroupList(arr) {
            const result = []
            for (let i = 0; i < arr.length; i += 3) {
                result.push(arr.slice(i, i + 3))
            }
            return result
        },
        toPageFn(url) {
            this.$router.push(url)
        },
        windowOpenFn(item) {
            if (item.video_url) {
                // window.open(item.video_url, '_blank')
                this.$router.push('/video?url=' + item.video_url+'&title=' + item.news_title)
            } else {
                window.open(item.url, '_blank')
            }
        },
        getNewsFn() {
            this.loading = true;
            this.$http.news_list({
                type_id: 755,
                page: 1,
                pagesize: 4
            }).then(res => {
                this.loading = false;
                this.newsList = res.data;
                console.log(this.newsList, 'this.newsList')
            })
        },
        getOrganizersFn() {
            this.loading = true;
            this.$http.news_list({
                type_id: 855,
                page: 1,
                pagesize: 7
            }).then(res => {
                this.loading = false;
                this.organizerList = res.data;
                console.log(this.organizerList, 'this.organizerList')
            })
        }
    },
    components: {
    }
}
</script>

<style lang="less" scoped>
.home {
    .banner {
        .con {
            justify-content: flex-start;
        }

    }

    .six-title {
        margin-top: 60px;
    }

    .section-1 {
        padding: 110px 0;
        background: #F8FAFC;

        .lists {
            display: flex;
            margin-top: 80px;
            flex-wrap: wrap;
        }

        .list {
            background: #fff;
            margin-right: 20px;
            margin-bottom: 20px;
            border-radius: 20px;
            padding: 30px 30px;
            box-sizing: border-box;
            transition: all .3s;
            border: 1px solid #00000040;
        }


        .num {
            color: #DBAE00;
            font-size: 48px;
            font-weight: bold;
            margin-bottom: 20px;

        }


        .name {
            font-size: 28px;
            font-weight: 500;
            margin-bottom: 50px;
            height: 40px;
        }

        .list-text {
            font-size: 18px;
            font-weight: 500;
            color: #777;
            line-height: 1.3;
        }

        // .list:hover {
        //     box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
        //     transform: scale(1.1);
        // }

        .list-1 {
            width: 25%
        }

        .list-2 {
            width: 30%;
        }

        .list-3 {
            margin-right: 0;
            width: calc(45% - 40px);
        }

        .list-img img {
            width: 100%;
            height: auto;
        }

        .list-6,
        .list-4,
        .list-5 {
            width: calc(33.3% - 14px);
            margin-bottom: 0;
        }

        .list-6 {
            margin-right: 0;
        }
    }

    .section-2 {
        padding: 110px 0;

        .word-con {
            display: flex;
            justify-content: space-between;
            border-radius: 20px;
            padding: 80px 40px;
            box-sizing: border-box;
            background: #F8FAFC;
            border: 1px solid #E1E3E5;
        }

        .pics {
            width: 700px;
            flex-shrink: 0;
            margin-right: 80px;

            img {
                width: 100%;
                height: auto;
                border-radius: 20px;
                box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
            }
        }

        .tip {
            font-size: 16px;
            color: #777;
            text-align: center;
            margin-top: 24px;
        }

        .word-con {
            flex: 1;

            p {
                color: #777;
                line-height: 1.2;
                margin-bottom: 15px;
                font-size: 18px;
            }
        }

        .word-title {
            color: #DBAE00;
            font-size: 24px;
            margin-bottom: 20px;
            font-weight: 700;
        }

        .name {
            position: relative;
            padding-top: 30px;
            color: #0065FF;
            font-size: 28px;
            margin-bottom: 10px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 10px;
                width: 300px;
                height: 2px;
                background: #0065FF;
            }
        }

        .desc {
            font-size: 18px;
            margin-bottom: 5px;
        }

        .desc-text {
            color: #777;
            line-height: 1.2;
            font-size: 18px;
        }

    }

    .section-3 {
        padding: 110px 0;
        background: #F8FAFC;
        border-top: 1px solid #ddd;

        .lists {
            display: flex;
            flex-wrap: wrap;
            margin-top: 30px;
            // height: 900px;
            position: relative;
            min-height: 400px;
        }

        .list {
            margin-bottom: 20px;
            width: calc(33.3% - 16px);
            border-radius: 20px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            border: 1px solid #E1E3E5;
            margin-right: 20px;
            box-sizing: border-box;
            background: #fff;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
        }

        .list:nth-of-type(3n) {
            margin-right: 0;
        }

        .page-con {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 50px;
            transform: scale(1.2);
        }

        .text-con {
            height: 160px;
            padding: 20px 30px;
            flex-shrink: 0;
            box-sizing: border-box;
        }

        .img {
            width: 100%;
            flex: 1;
            overflow: hidden;
            position: relative;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            i {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 60px;
                width: 100px;
                height: 100px;
                border: 6px solid #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
            }
        }

        .time {
            color: #0065FF;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 10px;
        }

        .name {
            font-size: 20px;
            font-weight: 500;
        }

    }



    .section-4 {
        padding: 110px 0;

        .text-con {
            color: #0065FF;
            font-size: 24px;
            font-weight: 500;
            margin-top: -20px;
            text-align: center;
        }

        .lists {
            display: flex;
            flex-wrap: wrap;
            margin-top: 130px;
            position: relative;
        }

        .list {
            width: 25%;
            text-align: center;
            margin-bottom: 80px;
        }

        .imgs {
            height: 100px;
            font-size: 50px;
            color: #777
        }

        img {
            height: 60px;
            width: auto;
        }

        .list-title {
            font-size: 22px;
            color: #777777;
            line-height: 30px;
            padding: 0 60px;
            font-weight: 400;
            box-sizing: border-box;
        }

        .num {
            text-align: center;
            font-size: 48px;
            font-weight: 700;
            color: #DBAE00
        }

        .num-desc {
            text-align: center;
            font-size: 24px;
            margin-top: 20px;
        }
    }

    /deep/ .el-carousel__button {
        background-color: #0065FF;
        height: 4px;
    }

    /deep/.el-carousel--horizontal {
        height: 800px;
        margin-top: 20px;
    }

    /deep/.el-carousel__indicators--horizontal {
        margin-top: 50px;
    }

    @media screen and (max-width: 768px) {
        .banner .con {
            padding-left: 15px;
            box-sizing: border-box;
        }

        .w-1200 {
            padding: 0 15px;
        }

        .big-title {
            font-size: 28px !important;
        }

        .section-1 {
            padding: 50px 10px;

            .lists {
                margin-top: 40px;
                flex-direction: column;
            }

            .list {
                width: 100%;
                margin-right: 0;
                padding: 20px;
            }

            .list-1,
            .list-2,
            .list-3,
            .list-4,
            .list-5,
            .list-6 {
                width: 100%;
                margin-right: 0;
            }

            .list-4,
            .list-5,
            .list-6 {
                margin-bottom: 20px;
            }

            .num {
                font-size: 36px;
            }

            .name {
                font-size: 22px;
                height: auto;
                margin-bottom: 20px;
            }

            .list-text {
                font-size: 14px;
            }
        }

        .section-2 {
            padding: 50px 10px;

            .word-con {
                flex-direction: column;
                padding: 30px 20px;
            }

            .pics {
                width: 100%;
                margin-right: 0;
                margin-bottom: 20px;

                img {
                    width: 100%;
                    box-shadow: none;
                }
            }

            .tip {
                font-size: 14px;
            }

            .word-title {
                font-size: 20px;
            }

            p {
                font-size: 15px;
            }

            .name {
                font-size: 22px;
                padding-top: 20px;

                &::before {
                    width: 200px;
                    top: 5px;
                }
            }

            .desc {
                font-size: 16px;
            }

            .desc-text {
                font-size: 14px;
            }
        }

        .section-3 {
            padding: 50px 10px;

            .lists {
                flex-direction: column;
                height: auto;
                margin-top: 20px;
            }

            .list {
                width: 100%;
                height: auto;
                margin-right: 0;
                margin-bottom: 15px;
            }

            // .list-2,
            // .list-3 {
            //     width: 100%;
            //     height: auto;
            //     position: static;
            //     margin-bottom: 15px;
            // }

            .text-con {
                height: auto;
                padding: 20px;
            }

            .img {
                height: 200px;


                i {
                    width: 50px;
                    height: 50px;
                    font-size: 30px;
                }
            }

            .time {
                font-size: 16px;
            }

            .name {
                font-size: 20px;
            }
        }

        .section-4 {
            padding: 50px 10px;

            .text-con {
                font-size: 18px;
            }

            .lists {
                margin-top: 60px;
            }

            .list {
                width: 50%;
                margin-bottom: 40px;
            }

            .imgs {
                height: 70px;
                font-size: 35px;
            }

            img {
                height: 50px;
            }

            .list-title {
                font-size: 18px;
                padding: 0 10px;
            }

            .num {
                font-size: 36px;
            }

            .num-desc {
                font-size: 18px;
            }
        }

        .read-more-btn {
            font-size: 16px;
            padding: 10px 30px;
        }
    }

    @media screen and (max-width: 480px) {


        .w-1200 {
            padding: 0 10px;
        }

        .big-title {
            font-size: 22px !important;
        }

        .section-1 {
            padding: 40px 10px;

            .lists {
                margin-top: 30px;
            }

            .list {
                padding: 15px;
            }

            .num {
                font-size: 28px;
            }

            .name {
                font-size: 18px;
            }

            .list-text {
                font-size: 13px;
            }
        }

        .section-2 {
            padding: 40px 10px;

            .word-con {
                padding: 0;
                border: none;
                background: none;
            }

            .tip {
                font-size: 13px;
            }

            .word-text {
                p {
                    font-size: 14px;
                }
            }

            .h5-bg {
                padding: 15px;
                border-radius: 20px;
                border: 1px solid #F8FAFC;
                background: #F8FAFC;
            }

            .h5-padding {
                padding: 0 15px;
                box-sizing: border-box;
            }

            .word-title {
                font-size: 16px;
            }

            .name {
                font-size: 18px;
                padding-bottom: 10px;

                &::before {
                    width: 150px;
                    top: 100%;
                    left: 0;
                    height: 1px;
                    transform: translateX(0);
                }
            }

            .desc {
                font-size: 14px;
                margin-bottom: 10px;
            }

            .desc-text {
                font-size: 13px;
            }
        }

        .section-3 {
            padding: 40px 10px;

            .img {
                height: 150px;
            }

            .time {
                font-size: 14px;
            }

            .name {
                font-size: 16px;
            }
        }

        .section-4 {
            padding: 40px 10px;

            .text-con {
                font-size: 16px;
            }

            .lists {
                margin-top: 40px;
            }

            .list {
                width: 50%;
                margin-bottom: 30px;
            }

            .imgs {
                height: 60px;
                font-size: 30px;
            }

            img {
                height: 30px;
                // width: 40px;
                max-height: 40px;
            }

            .list:nth-of-type(2) img {
                height: 20px;
            }

            .list-title {
                font-size: 12px;
                color: #000;
                line-height: 1.2;
                // display: none;
            }

            .num {
                font-size: 28px;
            }

            .num-desc {
                font-size: 16px;
            }

            // .img-list-more {
            //     display: none;
            // }
        }

        .read-more-btn {
            font-size: 14px;
            padding: 8px 25px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue